(function () {
    'use strict';
    var m = angular.module('app');
    m.directive('bannerV2', ["path", "brandInfo", "feature", function (path, brandInfo, feature) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('main').directive('banner-v2').template(),
            scope: { bannerMode: '=' },
            link: function ($scope) {
                $scope.hidePortalBanner = sessionStorage.getItem('hidePortalBanner');
                $scope.tempHide = false;
                feature.init(false, true).then(function () {
                    $scope.switchToUi2Flag = feature.enableSwitchToUI2Banner;
                });
                $scope.$on('$routeChangeSuccess', function ($event, current, previous) {
                    if ($scope.hidePortalBanner === 'true')
                        return;
                    if (current.$$route.name === 'wizard') {
                        $scope.tempHide = true;
                    } else {
                        $scope.tempHide = false;
                    }
                });
                $scope.takeButtonClicked = function () {
                    window.location.href = 'https://' + brandInfo.appendPortalToCustomerDomain();
                    $scope.dismissBanner();
                };
                $scope.dismissBanner = function () {
                    sessionStorage.setItem('hidePortalBanner', 'true');
                    $scope.hidePortalBanner = 'true';
                };
            }
        };
    }]);
}());